module.exports = __webpack_public_path__ + "img/leaf-left.4e24c985.png";